import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Home, Layers, Video, Search } from "lucide-react";
import { useContent } from "@/hooks/useData";

const ICONS = [Home, Layers, Video, Search];

export const WhyChoose = () => {
  const { content } = useContent();
  const c = content.why;
  return (
    <section className="bg-[#F6F5F2]" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32">
        <SectionHeading eyebrow={c.eyebrow} title={c.title} accent={c.accent} description={c.description} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#ECEAE4] mt-14 border border-[#ECEAE4]">
          {c.items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.08} className="bg-[#FFFFFF] p-8 sm:p-10 group">
                <div className="flex items-start justify-between">
                  <Icon size={28} className="text-[#9E8773]" strokeWidth={1.4} />
                  <span className="font-display text-3xl text-[#D8D3C9] group-hover:text-[#9E8773] transition-colors">0{i + 1}</span>
                </div>
                <h3 className="font-display text-2xl font-medium text-[#2C2A29] mt-6">{it.title}</h3>
                <p className="text-[#5E5A54] font-light leading-relaxed mt-3">{it.description}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
